module.exports = __webpack_public_path__ + "static/media/pink_bg.a872b21d.png";